<div class="side-nav-wrapper">
  <h5 class="title text-primary">Select Parameters</h5>
  <hr />

  <div class="param-box">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="adiabaticEfficiency"
        [(ngModel)]="adiabaticEfficiency"
        (change)="onAdiabaticEfficiencyToggle()" />
      <label class="form-check-label" for="adiabaticEfficiency">Show Adiabatic Efficiency</label>
    </div>
  </div>
  <div class="param-box">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="totalEfficiency"
        [(ngModel)]="totalEfficiency"
        (change)="onTotalEfficiencyToggle()" />
      <label class="form-check-label" for="totalEfficiency">Show Total Efficiency</label>
    </div>
  </div>
  <div class="param-box">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="heatRecoveryUsed"
        [(ngModel)]="heatRecoveryUsed"
        (change)="onHeatRecoveryToggle()" />
      <label class="form-check-label" for="heatRecoveryUsed">Heat Recovery Used</label>
    </div>
  </div>

  <div class="param-box">
    <h6>Motor Used</h6>
    @for (motor of motorOptions; track motor) {
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          [id]="motor.label"
          [(ngModel)]="motor.checked"
          (change)="onMotorOptionChange(motor.label, motor.checked)" />
        <label class="form-check-label motor-option" [for]="motor.label">{{ motor.label }}</label>
      </div>
    }
  </div>
</div>
